import { createFileRoute } from '@tanstack/react-router';

import { AuthorizedMcpClientsPage } from '@/components/features/authorized-mcp-clients/AuthorizedMcpClientsPage';

export const Route = createFileRoute('/_protected/authorized-mcp-clients')({
  component: AuthorizedMcpClientsPage,
});
